<template>
    <crud-facecade
        :url="url"
        :columns="columnList"
        :buttons="buttons"
        v-wechat-title="title"
        :tableHeight="tableHeight"
        :addButton="{ permission: 'nursing_record_tmp:add' }"
        :deleteButton="{ permission: 'nursing_record_tmp:delete' }"
        :updateButton="{ permission: 'nursing_record_tmp:edit' }"
    >
    </crud-facecade>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `NursingRecordTemplate`,
    props: {},
    data() {
        return {
            title: `护理记录模板`,
            url: { baseURL: `/api/AcisSystem/NursingRecordTemplate` },
            buttons: []
        }
    },
    computed: {
        ...mapGetters([`permissions`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `180`,
                    isListable: true,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    readonly: false,
                    sortable: true,
                    isDisplayOrder: true
                },
                {
                    type: `textarea`,
                    prop: `text_value`,
                    label: `模板内容`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: true,
                    config: {
                        minRows: 3
                    },
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
                },
                {
                    type: `string`,
                    prop: `description`,
                    label: `模板说明`,
                    width: `300`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true
                },
                {
                    type: `rbool`,
                    prop: `is_deleted`,
                    label: `状态`,
                    width: `100`,
                    isListable: true,
                    isExpand: false,
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    sortable: false,
                    readonly: false,
                    options: `is_enabled`,
                    default: false
                }
            ]
        }
    },
    mounted() {},
    methods: {}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/NursingRecordTemplate/Index.vue